import { ReactElement } from 'react';
import LandingPageV1 from '@/components/LandingPage/LandingPageV1';
import { Partner, partners } from 'lib/partners';
import LandingAdvantage from '@/components/FeatureSection/LandingAdvantage';
import SlimFooter from '@/components/Footer/SlimFooter';
import WhatOurCustomersAreSaying from '@/components/FeatureSection/WhatOurCustomersAreSaying';
import FullWidthFormSection from '@/components/LeadForm/FullWidthFormSection';

export async function getStaticPaths() {
  const paths = partners.map((partner) => ({ params: { slug: partner.slug } }));
  return { paths, fallback: false };
}

type StaticProps = {
  params: {
    slug: string;
  };
};

export async function getStaticProps({ params: { slug } }: StaticProps) {
  const partner = partners.find((partner) => partner.slug === slug);
  return { props: { partner } };
}

type Props = {
  partner: Partner;
};

export default function Page({ partner }: Props) {
  return (
    <>
      <main>
        <LandingPageV1 {...partner} />
      </main>
      <LandingAdvantage />
      {partner.includeReviews && <WhatOurCustomersAreSaying />}
      <FullWidthFormSection cid={partner.cid} />
      <SlimFooter />
    </>
  );
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
